import { useTranslation } from 'react-i18next';
import { Save } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface SaveButtonProps {
  onClick: (formData?: unknown) => void | Promise<void>;
  isLoading?: boolean;
}

export function SaveButton({ onClick, isLoading = false }: SaveButtonProps) {
  const { t } = useTranslation();

  return (
    <Button onClick={onClick} size="sm" disabled={isLoading}>
      <Save className="h-4 w-4 mr-2" />
      {t('newcmr.create.label', 'Save New Consignment')}
    </Button>
  );
}
